// feature name
export const LANGUAGE = "[LANGUAGE]";
export const DICTIONARY = "[DICTIONARY]";

// action types
export const SET_LANGUAGE = `${LANGUAGE} SET`;
export const GET_LANGUAGE = `${LANGUAGE} GET`;
export const GET_LANGUAGES = `${LANGUAGE} GETALL`;
export const GET_DICTIONARY = `${DICTIONARY} GET`;
export const SET_DICTIONARY = `${DICTIONARY} SET`;
export const RESULT = `${LANGUAGE} ${DICTIONARY} RESULT`;

// action creators
export const setLanguage = (id: string) => ({
  type: SET_LANGUAGE,
  // callback: callback,
  payload: id,
  meta: SET_LANGUAGE,
});

export const getLanguage = (id: string) => ({
  type: GET_LANGUAGE,
  payload: id,
  meta: GET_LANGUAGE,
});

export const getLanguages = () => ({
  type: GET_LANGUAGES,
  meta: GET_LANGUAGES,
});

export const setDictionary = (data: object) => ({
  type: SET_DICTIONARY,
  payload: data,
  meta: SET_DICTIONARY,
});

export const getDictionary = (
  // callback: (res: any, err?: any) => void,
  id: string
) => ({
  type: GET_DICTIONARY,
  // callback: callback,
  payload: id,
  meta: GET_DICTIONARY,
});

export const setResult = (payload: any, meta: any) => ({
  type: RESULT,
  payload: payload,
  meta: meta,
});
